// This file is auto-generated by @hey-api/openapi-ts

import {
  type DefaultError,
  type InfiniteData,
  infiniteQueryOptions,
  queryOptions,
  type UseMutationOptions,
} from "@tanstack/react-query";

import { client } from "../client.gen";
import {
  appAnalyticsControllerGetCyclesV1,
  appAnalyticsControllerGetDefectCreditsV1,
  appAnalyticsControllerGetDefectRatesV1,
  appAnalyticsControllerGetDefectsV1,
  appAnalyticsControllerGetDefectTimelineV1,
  appAnalyticsControllerGetImpactV1,
  appAnalyticsControllerGetLocationsImbalanceV1,
  appAnalyticsControllerGetScanLocationDwellTimeV1,
  appAnalyticsControllerGetScanLocationInventoryHealthV1,
  appAnalyticsControllerGetScanLocationUserActivityV1,
  appAnalyticsControllerGetScanLocationVolumeV1,
  appAnalyticsControllerGetTimeSeriesV1,
  appAnalyticsControllerGetUsageV1,
  appBillingControllerCancelSubscriptionV1,
  appBillingControllerChangeTierV1,
  appBillingControllerCreateCheckoutV1,
  appBillingControllerCreatePortalSessionV1,
  appBillingControllerCreateShopifyAddonCheckoutV1,
  appBillingControllerGetInvoicesV1,
  appBillingControllerGetSubscriptionV1,
  appBillingControllerReconcileStripeV1,
  appContractsControllerFindAllV1,
  appContractsControllerFindByIdV1,
  appContractsControllerRenewContractV1,
  appExternalDestinationsControllerCreateV1,
  appExternalDestinationsControllerFindAllV1,
  appExternalDestinationsControllerFindByIdV1,
  appExternalDestinationsControllerReconcileGeocoordinatesV1,
  appExternalDestinationsControllerUpdateV1,
  appOnboardingControllerCompleteProfileV1,
  appOnboardingControllerCreateCheckoutSessionV1,
  appOnboardingControllerGetProgressV1,
  appOnboardingControllerRegisterGoogleV1,
  appOnboardingControllerRegisterV1,
  appOnboardingControllerVerifyEmailV1,
  appPackageEventsControllerCreateV1,
  appPackageEventsControllerFindAllV1,
  appPackagesControllerCreateV1,
  appPackagesControllerFindAllV1,
  appPackagesControllerFindByIdV1,
  appPackagingsControllerFindAllV1,
  appPackagingsControllerFindByCodeV1,
  appPackagingsControllerFindByIdV1,
  appScanLocationsControllerAssignUserV1,
  appScanLocationsControllerBulkAddUsersV1,
  appScanLocationsControllerCreateV1,
  appScanLocationsControllerDeactivateV1,
  appScanLocationsControllerFindAllV1,
  appScanLocationsControllerFindByIdV1,
  appScanLocationsControllerFindByIdWithDetailsV1,
  appScanLocationsControllerGeocodeV1,
  appScanLocationsControllerGetAssignedUsersV1,
  appScanLocationsControllerGetStatsV1,
  appScanLocationsControllerReconcileGeocoordinatesV1,
  appScanLocationsControllerSearchUsersV1,
  appScanLocationsControllerUnassignUserV1,
  appScanLocationsControllerUpdateV1,
  appShopifyControllerAssociatePackageWithOrderV1,
  appShopifyControllerConnectV1,
  appShopifyControllerDisconnectV1,
  appShopifyControllerGetRecentOrdersV1,
  appShopifyControllerGetSettingsV1,
  appShopifyControllerGetStatusV1,
  appShopifyControllerSearchOrdersV1,
  appShopifyControllerSyncOrdersV1,
  appShopifyControllerUpdateSettingsV1,
  appShopsControllerFindAllV1,
  appTeamControllerChangeRoleV1,
  appTeamControllerFindAllV1,
  appTeamControllerInviteV1,
  appTeamControllerRemoveV1,
  authControllerConfirmEmailV1,
  authControllerConfirmNewEmailV1,
  authControllerDeleteV1,
  authControllerForgotPasswordV1,
  authControllerLoginV1,
  authControllerLogoutV1,
  authControllerMeV1,
  authControllerRefreshV1,
  authControllerRegisterV1,
  authControllerResetPasswordV1,
  authControllerUpdateV1,
  type Options,
} from "../sdk.gen";
import type {
  AppAnalyticsControllerGetCyclesV1Data,
  AppAnalyticsControllerGetCyclesV1Response,
  AppAnalyticsControllerGetDefectCreditsV1Data,
  AppAnalyticsControllerGetDefectCreditsV1Response,
  AppAnalyticsControllerGetDefectRatesV1Data,
  AppAnalyticsControllerGetDefectRatesV1Response,
  AppAnalyticsControllerGetDefectsV1Data,
  AppAnalyticsControllerGetDefectsV1Response,
  AppAnalyticsControllerGetDefectTimelineV1Data,
  AppAnalyticsControllerGetDefectTimelineV1Response,
  AppAnalyticsControllerGetImpactV1Data,
  AppAnalyticsControllerGetImpactV1Response,
  AppAnalyticsControllerGetLocationsImbalanceV1Data,
  AppAnalyticsControllerGetLocationsImbalanceV1Response,
  AppAnalyticsControllerGetScanLocationDwellTimeV1Data,
  AppAnalyticsControllerGetScanLocationDwellTimeV1Response,
  AppAnalyticsControllerGetScanLocationInventoryHealthV1Data,
  AppAnalyticsControllerGetScanLocationInventoryHealthV1Response,
  AppAnalyticsControllerGetScanLocationUserActivityV1Data,
  AppAnalyticsControllerGetScanLocationUserActivityV1Response,
  AppAnalyticsControllerGetScanLocationVolumeV1Data,
  AppAnalyticsControllerGetScanLocationVolumeV1Response,
  AppAnalyticsControllerGetTimeSeriesV1Data,
  AppAnalyticsControllerGetTimeSeriesV1Response,
  AppAnalyticsControllerGetUsageV1Data,
  AppAnalyticsControllerGetUsageV1Response,
  AppBillingControllerCancelSubscriptionV1Data,
  AppBillingControllerChangeTierV1Data,
  AppBillingControllerCreateCheckoutV1Data,
  AppBillingControllerCreatePortalSessionV1Data,
  AppBillingControllerCreateShopifyAddonCheckoutV1Data,
  AppBillingControllerGetInvoicesV1Data,
  AppBillingControllerGetInvoicesV1Response,
  AppBillingControllerGetSubscriptionV1Data,
  AppBillingControllerGetSubscriptionV1Response,
  AppBillingControllerReconcileStripeV1Data,
  AppBillingControllerReconcileStripeV1Response,
  AppContractsControllerFindAllV1Data,
  AppContractsControllerFindByIdV1Data,
  AppContractsControllerFindByIdV1Response,
  AppContractsControllerRenewContractV1Data,
  AppContractsControllerRenewContractV1Response,
  AppExternalDestinationsControllerCreateV1Data,
  AppExternalDestinationsControllerCreateV1Response,
  AppExternalDestinationsControllerFindAllV1Data,
  AppExternalDestinationsControllerFindAllV1Response,
  AppExternalDestinationsControllerFindByIdV1Data,
  AppExternalDestinationsControllerFindByIdV1Response,
  AppExternalDestinationsControllerReconcileGeocoordinatesV1Data,
  AppExternalDestinationsControllerReconcileGeocoordinatesV1Response,
  AppExternalDestinationsControllerUpdateV1Data,
  AppExternalDestinationsControllerUpdateV1Response,
  AppOnboardingControllerCompleteProfileV1Data,
  AppOnboardingControllerCompleteProfileV1Response,
  AppOnboardingControllerCreateCheckoutSessionV1Data,
  AppOnboardingControllerGetProgressV1Data,
  AppOnboardingControllerGetProgressV1Response,
  AppOnboardingControllerRegisterGoogleV1Data,
  AppOnboardingControllerRegisterGoogleV1Response,
  AppOnboardingControllerRegisterV1Data,
  AppOnboardingControllerRegisterV1Response,
  AppOnboardingControllerVerifyEmailV1Data,
  AppOnboardingControllerVerifyEmailV1Response,
  AppPackageEventsControllerCreateV1Data,
  AppPackageEventsControllerCreateV1Response,
  AppPackageEventsControllerFindAllV1Data,
  AppPackageEventsControllerFindAllV1Response,
  AppPackagesControllerCreateV1Data,
  AppPackagesControllerCreateV1Response,
  AppPackagesControllerFindAllV1Data,
  AppPackagesControllerFindAllV1Response,
  AppPackagesControllerFindByIdV1Data,
  AppPackagesControllerFindByIdV1Response,
  AppPackagingsControllerFindAllV1Data,
  AppPackagingsControllerFindAllV1Response,
  AppPackagingsControllerFindByCodeV1Data,
  AppPackagingsControllerFindByCodeV1Response,
  AppPackagingsControllerFindByIdV1Data,
  AppPackagingsControllerFindByIdV1Response,
  AppScanLocationsControllerAssignUserV1Data,
  AppScanLocationsControllerBulkAddUsersV1Data,
  AppScanLocationsControllerBulkAddUsersV1Response,
  AppScanLocationsControllerCreateV1Data,
  AppScanLocationsControllerCreateV1Response,
  AppScanLocationsControllerDeactivateV1Data,
  AppScanLocationsControllerFindAllV1Data,
  AppScanLocationsControllerFindAllV1Response,
  AppScanLocationsControllerFindByIdV1Data,
  AppScanLocationsControllerFindByIdV1Response,
  AppScanLocationsControllerFindByIdWithDetailsV1Data,
  AppScanLocationsControllerFindByIdWithDetailsV1Response,
  AppScanLocationsControllerGeocodeV1Data,
  AppScanLocationsControllerGeocodeV1Response,
  AppScanLocationsControllerGetAssignedUsersV1Data,
  AppScanLocationsControllerGetAssignedUsersV1Response,
  AppScanLocationsControllerGetStatsV1Data,
  AppScanLocationsControllerGetStatsV1Response,
  AppScanLocationsControllerReconcileGeocoordinatesV1Data,
  AppScanLocationsControllerReconcileGeocoordinatesV1Response,
  AppScanLocationsControllerSearchUsersV1Data,
  AppScanLocationsControllerSearchUsersV1Response,
  AppScanLocationsControllerUnassignUserV1Data,
  AppScanLocationsControllerUnassignUserV1Response,
  AppScanLocationsControllerUpdateV1Data,
  AppScanLocationsControllerUpdateV1Response,
  AppShopifyControllerAssociatePackageWithOrderV1Data,
  AppShopifyControllerAssociatePackageWithOrderV1Response,
  AppShopifyControllerConnectV1Data,
  AppShopifyControllerConnectV1Response,
  AppShopifyControllerDisconnectV1Data,
  AppShopifyControllerDisconnectV1Response,
  AppShopifyControllerGetRecentOrdersV1Data,
  AppShopifyControllerGetRecentOrdersV1Response,
  AppShopifyControllerGetSettingsV1Data,
  AppShopifyControllerGetSettingsV1Response,
  AppShopifyControllerGetStatusV1Data,
  AppShopifyControllerGetStatusV1Response,
  AppShopifyControllerSearchOrdersV1Data,
  AppShopifyControllerSearchOrdersV1Response,
  AppShopifyControllerSyncOrdersV1Data,
  AppShopifyControllerSyncOrdersV1Response,
  AppShopifyControllerUpdateSettingsV1Data,
  AppShopifyControllerUpdateSettingsV1Response,
  AppShopsControllerFindAllV1Data,
  AppShopsControllerFindAllV1Response,
  AppTeamControllerChangeRoleV1Data,
  AppTeamControllerFindAllV1Data,
  AppTeamControllerFindAllV1Response,
  AppTeamControllerInviteV1Data,
  AppTeamControllerRemoveV1Data,
  AppTeamControllerRemoveV1Response,
  AuthControllerConfirmEmailV1Data,
  AuthControllerConfirmEmailV1Response,
  AuthControllerConfirmNewEmailV1Data,
  AuthControllerConfirmNewEmailV1Response,
  AuthControllerDeleteV1Data,
  AuthControllerDeleteV1Response,
  AuthControllerForgotPasswordV1Data,
  AuthControllerForgotPasswordV1Response,
  AuthControllerLoginV1Data,
  AuthControllerLoginV1Response,
  AuthControllerLogoutV1Data,
  AuthControllerLogoutV1Response,
  AuthControllerMeV1Data,
  AuthControllerMeV1Response,
  AuthControllerRefreshV1Data,
  AuthControllerRefreshV1Response,
  AuthControllerRegisterV1Data,
  AuthControllerRegisterV1Response,
  AuthControllerResetPasswordV1Data,
  AuthControllerResetPasswordV1Response,
  AuthControllerUpdateV1Data,
  AuthControllerUpdateV1Response,
} from "../types.gen";

/**
 * Create a Stripe checkout session for subscription
 */
export const appBillingControllerCreateCheckoutV1Mutation = (
  options?: Partial<Options<AppBillingControllerCreateCheckoutV1Data>>
): UseMutationOptions<unknown, DefaultError, Options<AppBillingControllerCreateCheckoutV1Data>> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    DefaultError,
    Options<AppBillingControllerCreateCheckoutV1Data>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await appBillingControllerCreateCheckoutV1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const appBillingControllerCreateShopifyAddonCheckoutV1Mutation = (
  options?: Partial<Options<AppBillingControllerCreateShopifyAddonCheckoutV1Data>>
): UseMutationOptions<
  unknown,
  DefaultError,
  Options<AppBillingControllerCreateShopifyAddonCheckoutV1Data>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    DefaultError,
    Options<AppBillingControllerCreateShopifyAddonCheckoutV1Data>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await appBillingControllerCreateShopifyAddonCheckoutV1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export type QueryKey<TOptions extends Options> = [
  Pick<TOptions, "baseUrl" | "body" | "headers" | "path" | "query"> & {
    _id: string;
    _infinite?: boolean;
    tags?: ReadonlyArray<string>;
  },
];

const createQueryKey = <TOptions extends Options>(
  id: string,
  options?: TOptions,
  infinite?: boolean,
  tags?: ReadonlyArray<string>
): [QueryKey<TOptions>[0]] => {
  const params: QueryKey<TOptions>[0] = {
    _id: id,
    baseUrl: options?.baseUrl || (options?.client ?? client).getConfig().baseUrl,
  } as QueryKey<TOptions>[0];
  if (infinite) {
    params._infinite = infinite;
  }
  if (tags) {
    params.tags = tags;
  }
  if (options?.body) {
    params.body = options.body;
  }
  if (options?.headers) {
    params.headers = options.headers;
  }
  if (options?.path) {
    params.path = options.path;
  }
  if (options?.query) {
    params.query = options.query;
  }
  return [params];
};

export const appBillingControllerGetSubscriptionV1QueryKey = (
  options?: Options<AppBillingControllerGetSubscriptionV1Data>
) => createQueryKey("appBillingControllerGetSubscriptionV1", options);

/**
 * Get current subscription details
 */
export const appBillingControllerGetSubscriptionV1Options = (
  options?: Options<AppBillingControllerGetSubscriptionV1Data>
) =>
  queryOptions<
    AppBillingControllerGetSubscriptionV1Response,
    DefaultError,
    AppBillingControllerGetSubscriptionV1Response,
    ReturnType<typeof appBillingControllerGetSubscriptionV1QueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await appBillingControllerGetSubscriptionV1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: appBillingControllerGetSubscriptionV1QueryKey(options),
  });

/**
 * Cancel current subscription
 */
export const appBillingControllerCancelSubscriptionV1Mutation = (
  options?: Partial<Options<AppBillingControllerCancelSubscriptionV1Data>>
): UseMutationOptions<
  unknown,
  DefaultError,
  Options<AppBillingControllerCancelSubscriptionV1Data>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    DefaultError,
    Options<AppBillingControllerCancelSubscriptionV1Data>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await appBillingControllerCancelSubscriptionV1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Change subscription tier
 */
export const appBillingControllerChangeTierV1Mutation = (
  options?: Partial<Options<AppBillingControllerChangeTierV1Data>>
): UseMutationOptions<unknown, DefaultError, Options<AppBillingControllerChangeTierV1Data>> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    DefaultError,
    Options<AppBillingControllerChangeTierV1Data>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await appBillingControllerChangeTierV1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Create Stripe Customer Portal session for payment management
 */
export const appBillingControllerCreatePortalSessionV1Mutation = (
  options?: Partial<Options<AppBillingControllerCreatePortalSessionV1Data>>
): UseMutationOptions<
  unknown,
  DefaultError,
  Options<AppBillingControllerCreatePortalSessionV1Data>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    DefaultError,
    Options<AppBillingControllerCreatePortalSessionV1Data>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await appBillingControllerCreatePortalSessionV1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const appBillingControllerGetInvoicesV1QueryKey = (
  options?: Options<AppBillingControllerGetInvoicesV1Data>
) => createQueryKey("appBillingControllerGetInvoicesV1", options);

/**
 * Get billing history with invoice download links
 */
export const appBillingControllerGetInvoicesV1Options = (
  options?: Options<AppBillingControllerGetInvoicesV1Data>
) =>
  queryOptions<
    AppBillingControllerGetInvoicesV1Response,
    DefaultError,
    AppBillingControllerGetInvoicesV1Response,
    ReturnType<typeof appBillingControllerGetInvoicesV1QueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await appBillingControllerGetInvoicesV1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: appBillingControllerGetInvoicesV1QueryKey(options),
  });

/**
 * Link or create a Stripe customer account for this company
 */
export const appBillingControllerReconcileStripeV1Mutation = (
  options?: Partial<Options<AppBillingControllerReconcileStripeV1Data>>
): UseMutationOptions<
  AppBillingControllerReconcileStripeV1Response,
  DefaultError,
  Options<AppBillingControllerReconcileStripeV1Data>
> => {
  const mutationOptions: UseMutationOptions<
    AppBillingControllerReconcileStripeV1Response,
    DefaultError,
    Options<AppBillingControllerReconcileStripeV1Data>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await appBillingControllerReconcileStripeV1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const appAnalyticsControllerGetImpactV1QueryKey = (
  options?: Options<AppAnalyticsControllerGetImpactV1Data>
) => createQueryKey("appAnalyticsControllerGetImpactV1", options);

/**
 * Get environmental impact analytics (CO2/waste savings by box type)
 */
export const appAnalyticsControllerGetImpactV1Options = (
  options?: Options<AppAnalyticsControllerGetImpactV1Data>
) =>
  queryOptions<
    AppAnalyticsControllerGetImpactV1Response,
    DefaultError,
    AppAnalyticsControllerGetImpactV1Response,
    ReturnType<typeof appAnalyticsControllerGetImpactV1QueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await appAnalyticsControllerGetImpactV1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: appAnalyticsControllerGetImpactV1QueryKey(options),
  });

export const appAnalyticsControllerGetUsageV1QueryKey = (
  options?: Options<AppAnalyticsControllerGetUsageV1Data>
) => createQueryKey("appAnalyticsControllerGetUsageV1", options);

/**
 * Get package usage analytics (idle/active time, shipments per package)
 */
export const appAnalyticsControllerGetUsageV1Options = (
  options?: Options<AppAnalyticsControllerGetUsageV1Data>
) =>
  queryOptions<
    AppAnalyticsControllerGetUsageV1Response,
    DefaultError,
    AppAnalyticsControllerGetUsageV1Response,
    ReturnType<typeof appAnalyticsControllerGetUsageV1QueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await appAnalyticsControllerGetUsageV1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: appAnalyticsControllerGetUsageV1QueryKey(options),
  });

export const appAnalyticsControllerGetCyclesV1QueryKey = (
  options?: Options<AppAnalyticsControllerGetCyclesV1Data>
) => createQueryKey("appAnalyticsControllerGetCyclesV1", options);

/**
 * Get package cycle analytics (reuse count distribution, defect rates)
 */
export const appAnalyticsControllerGetCyclesV1Options = (
  options?: Options<AppAnalyticsControllerGetCyclesV1Data>
) =>
  queryOptions<
    AppAnalyticsControllerGetCyclesV1Response,
    DefaultError,
    AppAnalyticsControllerGetCyclesV1Response,
    ReturnType<typeof appAnalyticsControllerGetCyclesV1QueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await appAnalyticsControllerGetCyclesV1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: appAnalyticsControllerGetCyclesV1QueryKey(options),
  });

export const appAnalyticsControllerGetTimeSeriesV1QueryKey = (
  options?: Options<AppAnalyticsControllerGetTimeSeriesV1Data>
) => createQueryKey("appAnalyticsControllerGetTimeSeriesV1", options);

/**
 * Get monthly time-series analytics (shipments, CO2/waste savings per packaging type)
 */
export const appAnalyticsControllerGetTimeSeriesV1Options = (
  options?: Options<AppAnalyticsControllerGetTimeSeriesV1Data>
) =>
  queryOptions<
    AppAnalyticsControllerGetTimeSeriesV1Response,
    DefaultError,
    AppAnalyticsControllerGetTimeSeriesV1Response,
    ReturnType<typeof appAnalyticsControllerGetTimeSeriesV1QueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await appAnalyticsControllerGetTimeSeriesV1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: appAnalyticsControllerGetTimeSeriesV1QueryKey(options),
  });

export const appAnalyticsControllerGetScanLocationVolumeV1QueryKey = (
  options: Options<AppAnalyticsControllerGetScanLocationVolumeV1Data>
) => createQueryKey("appAnalyticsControllerGetScanLocationVolumeV1", options);

/**
 * Get monthly scan volume for a location (SCAN event counts per month, last 12 months by default)
 */
export const appAnalyticsControllerGetScanLocationVolumeV1Options = (
  options: Options<AppAnalyticsControllerGetScanLocationVolumeV1Data>
) =>
  queryOptions<
    AppAnalyticsControllerGetScanLocationVolumeV1Response,
    DefaultError,
    AppAnalyticsControllerGetScanLocationVolumeV1Response,
    ReturnType<typeof appAnalyticsControllerGetScanLocationVolumeV1QueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await appAnalyticsControllerGetScanLocationVolumeV1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: appAnalyticsControllerGetScanLocationVolumeV1QueryKey(options),
  });

export const appAnalyticsControllerGetScanLocationDwellTimeV1QueryKey = (
  options: Options<AppAnalyticsControllerGetScanLocationDwellTimeV1Data>
) => createQueryKey("appAnalyticsControllerGetScanLocationDwellTimeV1", options);

/**
 * Get average package dwell time at a scan location (hours between SCAN arrival and SENT departure)
 */
export const appAnalyticsControllerGetScanLocationDwellTimeV1Options = (
  options: Options<AppAnalyticsControllerGetScanLocationDwellTimeV1Data>
) =>
  queryOptions<
    AppAnalyticsControllerGetScanLocationDwellTimeV1Response,
    DefaultError,
    AppAnalyticsControllerGetScanLocationDwellTimeV1Response,
    ReturnType<typeof appAnalyticsControllerGetScanLocationDwellTimeV1QueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await appAnalyticsControllerGetScanLocationDwellTimeV1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: appAnalyticsControllerGetScanLocationDwellTimeV1QueryKey(options),
  });

export const appAnalyticsControllerGetScanLocationUserActivityV1QueryKey = (
  options: Options<AppAnalyticsControllerGetScanLocationUserActivityV1Data>
) => createQueryKey("appAnalyticsControllerGetScanLocationUserActivityV1", options);

/**
 * Get per-user SCAN event counts at a scan location, ordered by scan count descending
 */
export const appAnalyticsControllerGetScanLocationUserActivityV1Options = (
  options: Options<AppAnalyticsControllerGetScanLocationUserActivityV1Data>
) =>
  queryOptions<
    AppAnalyticsControllerGetScanLocationUserActivityV1Response,
    DefaultError,
    AppAnalyticsControllerGetScanLocationUserActivityV1Response,
    ReturnType<typeof appAnalyticsControllerGetScanLocationUserActivityV1QueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await appAnalyticsControllerGetScanLocationUserActivityV1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: appAnalyticsControllerGetScanLocationUserActivityV1QueryKey(options),
  });

export const appAnalyticsControllerGetLocationsImbalanceV1QueryKey = (
  options?: Options<AppAnalyticsControllerGetLocationsImbalanceV1Data>
) => createQueryKey("appAnalyticsControllerGetLocationsImbalanceV1", options);

/**
 * Get paired-direction shipment imbalance across scan locations
 */
export const appAnalyticsControllerGetLocationsImbalanceV1Options = (
  options?: Options<AppAnalyticsControllerGetLocationsImbalanceV1Data>
) =>
  queryOptions<
    AppAnalyticsControllerGetLocationsImbalanceV1Response,
    DefaultError,
    AppAnalyticsControllerGetLocationsImbalanceV1Response,
    ReturnType<typeof appAnalyticsControllerGetLocationsImbalanceV1QueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await appAnalyticsControllerGetLocationsImbalanceV1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: appAnalyticsControllerGetLocationsImbalanceV1QueryKey(options),
  });

export const appAnalyticsControllerGetScanLocationInventoryHealthV1QueryKey = (
  options: Options<AppAnalyticsControllerGetScanLocationInventoryHealthV1Data>
) => createQueryKey("appAnalyticsControllerGetScanLocationInventoryHealthV1", options);

/**
 * Per-location box count + defect rate
 */
export const appAnalyticsControllerGetScanLocationInventoryHealthV1Options = (
  options: Options<AppAnalyticsControllerGetScanLocationInventoryHealthV1Data>
) =>
  queryOptions<
    AppAnalyticsControllerGetScanLocationInventoryHealthV1Response,
    DefaultError,
    AppAnalyticsControllerGetScanLocationInventoryHealthV1Response,
    ReturnType<typeof appAnalyticsControllerGetScanLocationInventoryHealthV1QueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await appAnalyticsControllerGetScanLocationInventoryHealthV1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: appAnalyticsControllerGetScanLocationInventoryHealthV1QueryKey(options),
  });

export const appAnalyticsControllerGetDefectTimelineV1QueryKey = (
  options?: Options<AppAnalyticsControllerGetDefectTimelineV1Data>
) => createQueryKey("appAnalyticsControllerGetDefectTimelineV1", options);

/**
 * Get monthly DEFECT event counts per packaging type for the last 12 months
 */
export const appAnalyticsControllerGetDefectTimelineV1Options = (
  options?: Options<AppAnalyticsControllerGetDefectTimelineV1Data>
) =>
  queryOptions<
    AppAnalyticsControllerGetDefectTimelineV1Response,
    DefaultError,
    AppAnalyticsControllerGetDefectTimelineV1Response,
    ReturnType<typeof appAnalyticsControllerGetDefectTimelineV1QueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await appAnalyticsControllerGetDefectTimelineV1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: appAnalyticsControllerGetDefectTimelineV1QueryKey(options),
  });

export const appAnalyticsControllerGetDefectRatesV1QueryKey = (
  options?: Options<AppAnalyticsControllerGetDefectRatesV1Data>
) => createQueryKey("appAnalyticsControllerGetDefectRatesV1", options);

/**
 * Get defect rate (%) per packaging type — DEFECT events / SCAN events * 100
 */
export const appAnalyticsControllerGetDefectRatesV1Options = (
  options?: Options<AppAnalyticsControllerGetDefectRatesV1Data>
) =>
  queryOptions<
    AppAnalyticsControllerGetDefectRatesV1Response,
    DefaultError,
    AppAnalyticsControllerGetDefectRatesV1Response,
    ReturnType<typeof appAnalyticsControllerGetDefectRatesV1QueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await appAnalyticsControllerGetDefectRatesV1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: appAnalyticsControllerGetDefectRatesV1QueryKey(options),
  });

export const appAnalyticsControllerGetDefectCreditsV1QueryKey = (
  options?: Options<AppAnalyticsControllerGetDefectCreditsV1Data>
) => createQueryKey("appAnalyticsControllerGetDefectCreditsV1", options);

/**
 * Get total EUR credit applied to company Stripe Customer Balance from defect reimbursements
 */
export const appAnalyticsControllerGetDefectCreditsV1Options = (
  options?: Options<AppAnalyticsControllerGetDefectCreditsV1Data>
) =>
  queryOptions<
    AppAnalyticsControllerGetDefectCreditsV1Response,
    DefaultError,
    AppAnalyticsControllerGetDefectCreditsV1Response,
    ReturnType<typeof appAnalyticsControllerGetDefectCreditsV1QueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await appAnalyticsControllerGetDefectCreditsV1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: appAnalyticsControllerGetDefectCreditsV1QueryKey(options),
  });

export const appAnalyticsControllerGetDefectsV1QueryKey = (
  options?: Options<AppAnalyticsControllerGetDefectsV1Data>
) => createQueryKey("appAnalyticsControllerGetDefectsV1", options);

/**
 * Get paginated list of individual DEFECT package events (packageId, packaging type, date, notes)
 */
export const appAnalyticsControllerGetDefectsV1Options = (
  options?: Options<AppAnalyticsControllerGetDefectsV1Data>
) =>
  queryOptions<
    AppAnalyticsControllerGetDefectsV1Response,
    DefaultError,
    AppAnalyticsControllerGetDefectsV1Response,
    ReturnType<typeof appAnalyticsControllerGetDefectsV1QueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await appAnalyticsControllerGetDefectsV1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: appAnalyticsControllerGetDefectsV1QueryKey(options),
  });

const createInfiniteParams = <
  K extends Pick<QueryKey<Options>[0], "body" | "headers" | "path" | "query">,
>(
  queryKey: QueryKey<Options>,
  page: K
) => {
  const params = { ...queryKey[0] };
  if (page.body) {
    params.body = {
      ...(queryKey[0].body as any),
      ...(page.body as any),
    };
  }
  if (page.headers) {
    params.headers = {
      ...queryKey[0].headers,
      ...page.headers,
    };
  }
  if (page.path) {
    params.path = {
      ...(queryKey[0].path as any),
      ...(page.path as any),
    };
  }
  if (page.query) {
    params.query = {
      ...(queryKey[0].query as any),
      ...(page.query as any),
    };
  }
  return params as unknown as typeof page;
};

export const appAnalyticsControllerGetDefectsV1InfiniteQueryKey = (
  options?: Options<AppAnalyticsControllerGetDefectsV1Data>
): QueryKey<Options<AppAnalyticsControllerGetDefectsV1Data>> =>
  createQueryKey("appAnalyticsControllerGetDefectsV1", options, true);

/**
 * Get paginated list of individual DEFECT package events (packageId, packaging type, date, notes)
 */
export const appAnalyticsControllerGetDefectsV1InfiniteOptions = (
  options?: Options<AppAnalyticsControllerGetDefectsV1Data>
) =>
  infiniteQueryOptions<
    AppAnalyticsControllerGetDefectsV1Response,
    DefaultError,
    InfiniteData<AppAnalyticsControllerGetDefectsV1Response>,
    QueryKey<Options<AppAnalyticsControllerGetDefectsV1Data>>,
    | number
    | Pick<
        QueryKey<Options<AppAnalyticsControllerGetDefectsV1Data>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<AppAnalyticsControllerGetDefectsV1Data>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  page: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await appAnalyticsControllerGetDefectsV1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: appAnalyticsControllerGetDefectsV1InfiniteQueryKey(options),
    }
  );

export const appPackagesControllerFindAllV1QueryKey = (
  options?: Options<AppPackagesControllerFindAllV1Data>
) => createQueryKey("appPackagesControllerFindAllV1", options);

/**
 * List all packages for your company
 */
export const appPackagesControllerFindAllV1Options = (
  options?: Options<AppPackagesControllerFindAllV1Data>
) =>
  queryOptions<
    AppPackagesControllerFindAllV1Response,
    DefaultError,
    AppPackagesControllerFindAllV1Response,
    ReturnType<typeof appPackagesControllerFindAllV1QueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await appPackagesControllerFindAllV1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: appPackagesControllerFindAllV1QueryKey(options),
  });

export const appPackagesControllerFindAllV1InfiniteQueryKey = (
  options?: Options<AppPackagesControllerFindAllV1Data>
): QueryKey<Options<AppPackagesControllerFindAllV1Data>> =>
  createQueryKey("appPackagesControllerFindAllV1", options, true);

/**
 * List all packages for your company
 */
export const appPackagesControllerFindAllV1InfiniteOptions = (
  options?: Options<AppPackagesControllerFindAllV1Data>
) =>
  infiniteQueryOptions<
    AppPackagesControllerFindAllV1Response,
    DefaultError,
    InfiniteData<AppPackagesControllerFindAllV1Response>,
    QueryKey<Options<AppPackagesControllerFindAllV1Data>>,
    | number
    | Pick<
        QueryKey<Options<AppPackagesControllerFindAllV1Data>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<AppPackagesControllerFindAllV1Data>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  page: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await appPackagesControllerFindAllV1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: appPackagesControllerFindAllV1InfiniteQueryKey(options),
    }
  );

/**
 * Register a new package for your company
 */
export const appPackagesControllerCreateV1Mutation = (
  options?: Partial<Options<AppPackagesControllerCreateV1Data>>
): UseMutationOptions<
  AppPackagesControllerCreateV1Response,
  DefaultError,
  Options<AppPackagesControllerCreateV1Data>
> => {
  const mutationOptions: UseMutationOptions<
    AppPackagesControllerCreateV1Response,
    DefaultError,
    Options<AppPackagesControllerCreateV1Data>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await appPackagesControllerCreateV1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const appPackagesControllerFindByIdV1QueryKey = (
  options: Options<AppPackagesControllerFindByIdV1Data>
) => createQueryKey("appPackagesControllerFindByIdV1", options);

/**
 * Get a package by ID
 */
export const appPackagesControllerFindByIdV1Options = (
  options: Options<AppPackagesControllerFindByIdV1Data>
) =>
  queryOptions<
    AppPackagesControllerFindByIdV1Response,
    DefaultError,
    AppPackagesControllerFindByIdV1Response,
    ReturnType<typeof appPackagesControllerFindByIdV1QueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await appPackagesControllerFindByIdV1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: appPackagesControllerFindByIdV1QueryKey(options),
  });

export const appPackageEventsControllerFindAllV1QueryKey = (
  options: Options<AppPackageEventsControllerFindAllV1Data>
) => createQueryKey("appPackageEventsControllerFindAllV1", options);

/**
 * List events for a package (cursor pagination)
 */
export const appPackageEventsControllerFindAllV1Options = (
  options: Options<AppPackageEventsControllerFindAllV1Data>
) =>
  queryOptions<
    AppPackageEventsControllerFindAllV1Response,
    DefaultError,
    AppPackageEventsControllerFindAllV1Response,
    ReturnType<typeof appPackageEventsControllerFindAllV1QueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await appPackageEventsControllerFindAllV1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: appPackageEventsControllerFindAllV1QueryKey(options),
  });

/**
 * Record a lifecycle event on a package
 */
export const appPackageEventsControllerCreateV1Mutation = (
  options?: Partial<Options<AppPackageEventsControllerCreateV1Data>>
): UseMutationOptions<
  AppPackageEventsControllerCreateV1Response,
  DefaultError,
  Options<AppPackageEventsControllerCreateV1Data>
> => {
  const mutationOptions: UseMutationOptions<
    AppPackageEventsControllerCreateV1Response,
    DefaultError,
    Options<AppPackageEventsControllerCreateV1Data>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await appPackageEventsControllerCreateV1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const appContractsControllerFindAllV1QueryKey = (
  options?: Options<AppContractsControllerFindAllV1Data>
) => createQueryKey("appContractsControllerFindAllV1", options);

/**
 * List all contracts for your company with capacity summary
 */
export const appContractsControllerFindAllV1Options = (
  options?: Options<AppContractsControllerFindAllV1Data>
) =>
  queryOptions<
    unknown,
    DefaultError,
    unknown,
    ReturnType<typeof appContractsControllerFindAllV1QueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await appContractsControllerFindAllV1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: appContractsControllerFindAllV1QueryKey(options),
  });

export const appContractsControllerFindAllV1InfiniteQueryKey = (
  options?: Options<AppContractsControllerFindAllV1Data>
): QueryKey<Options<AppContractsControllerFindAllV1Data>> =>
  createQueryKey("appContractsControllerFindAllV1", options, true);

/**
 * List all contracts for your company with capacity summary
 */
export const appContractsControllerFindAllV1InfiniteOptions = (
  options?: Options<AppContractsControllerFindAllV1Data>
) =>
  infiniteQueryOptions<
    unknown,
    DefaultError,
    InfiniteData<unknown>,
    QueryKey<Options<AppContractsControllerFindAllV1Data>>,
    | number
    | Pick<
        QueryKey<Options<AppContractsControllerFindAllV1Data>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<AppContractsControllerFindAllV1Data>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  page: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await appContractsControllerFindAllV1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: appContractsControllerFindAllV1InfiniteQueryKey(options),
    }
  );

/**
 * Accept contract renewal and extend end date (COMPANY_ADMIN only)
 */
export const appContractsControllerRenewContractV1Mutation = (
  options?: Partial<Options<AppContractsControllerRenewContractV1Data>>
): UseMutationOptions<
  AppContractsControllerRenewContractV1Response,
  DefaultError,
  Options<AppContractsControllerRenewContractV1Data>
> => {
  const mutationOptions: UseMutationOptions<
    AppContractsControllerRenewContractV1Response,
    DefaultError,
    Options<AppContractsControllerRenewContractV1Data>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await appContractsControllerRenewContractV1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const appContractsControllerFindByIdV1QueryKey = (
  options: Options<AppContractsControllerFindByIdV1Data>
) => createQueryKey("appContractsControllerFindByIdV1", options);

/**
 * Get contract by ID with capacity usage
 */
export const appContractsControllerFindByIdV1Options = (
  options: Options<AppContractsControllerFindByIdV1Data>
) =>
  queryOptions<
    AppContractsControllerFindByIdV1Response,
    DefaultError,
    AppContractsControllerFindByIdV1Response,
    ReturnType<typeof appContractsControllerFindByIdV1QueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await appContractsControllerFindByIdV1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: appContractsControllerFindByIdV1QueryKey(options),
  });

export const appScanLocationsControllerFindAllV1QueryKey = (
  options?: Options<AppScanLocationsControllerFindAllV1Data>
) => createQueryKey("appScanLocationsControllerFindAllV1", options);

/**
 * Get all scan locations for your company
 */
export const appScanLocationsControllerFindAllV1Options = (
  options?: Options<AppScanLocationsControllerFindAllV1Data>
) =>
  queryOptions<
    AppScanLocationsControllerFindAllV1Response,
    DefaultError,
    AppScanLocationsControllerFindAllV1Response,
    ReturnType<typeof appScanLocationsControllerFindAllV1QueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await appScanLocationsControllerFindAllV1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: appScanLocationsControllerFindAllV1QueryKey(options),
  });

export const appScanLocationsControllerFindAllV1InfiniteQueryKey = (
  options?: Options<AppScanLocationsControllerFindAllV1Data>
): QueryKey<Options<AppScanLocationsControllerFindAllV1Data>> =>
  createQueryKey("appScanLocationsControllerFindAllV1", options, true);

/**
 * Get all scan locations for your company
 */
export const appScanLocationsControllerFindAllV1InfiniteOptions = (
  options?: Options<AppScanLocationsControllerFindAllV1Data>
) =>
  infiniteQueryOptions<
    AppScanLocationsControllerFindAllV1Response,
    DefaultError,
    InfiniteData<AppScanLocationsControllerFindAllV1Response>,
    QueryKey<Options<AppScanLocationsControllerFindAllV1Data>>,
    | number
    | Pick<
        QueryKey<Options<AppScanLocationsControllerFindAllV1Data>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<AppScanLocationsControllerFindAllV1Data>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  page: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await appScanLocationsControllerFindAllV1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: appScanLocationsControllerFindAllV1InfiniteQueryKey(options),
    }
  );

/**
 * Create a new scan location
 */
export const appScanLocationsControllerCreateV1Mutation = (
  options?: Partial<Options<AppScanLocationsControllerCreateV1Data>>
): UseMutationOptions<
  AppScanLocationsControllerCreateV1Response,
  DefaultError,
  Options<AppScanLocationsControllerCreateV1Data>
> => {
  const mutationOptions: UseMutationOptions<
    AppScanLocationsControllerCreateV1Response,
    DefaultError,
    Options<AppScanLocationsControllerCreateV1Data>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await appScanLocationsControllerCreateV1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Geocode an address to coordinates
 *
 * Proxy endpoint to geocode addresses without CORS issues. Uses OpenStreetMap Nominatim.
 */
export const appScanLocationsControllerGeocodeV1Mutation = (
  options?: Partial<Options<AppScanLocationsControllerGeocodeV1Data>>
): UseMutationOptions<
  AppScanLocationsControllerGeocodeV1Response,
  DefaultError,
  Options<AppScanLocationsControllerGeocodeV1Data>
> => {
  const mutationOptions: UseMutationOptions<
    AppScanLocationsControllerGeocodeV1Response,
    DefaultError,
    Options<AppScanLocationsControllerGeocodeV1Data>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await appScanLocationsControllerGeocodeV1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Backfill geocoordinates for scan location addresses
 *
 * Finds all scan location addresses for your company that are missing latitude/longitude and geocodes them. Processes sequentially with 1-second delays to respect Nominatim rate limits.
 */
export const appScanLocationsControllerReconcileGeocoordinatesV1Mutation = (
  options?: Partial<Options<AppScanLocationsControllerReconcileGeocoordinatesV1Data>>
): UseMutationOptions<
  AppScanLocationsControllerReconcileGeocoordinatesV1Response,
  DefaultError,
  Options<AppScanLocationsControllerReconcileGeocoordinatesV1Data>
> => {
  const mutationOptions: UseMutationOptions<
    AppScanLocationsControllerReconcileGeocoordinatesV1Response,
    DefaultError,
    Options<AppScanLocationsControllerReconcileGeocoordinatesV1Data>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await appScanLocationsControllerReconcileGeocoordinatesV1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const appScanLocationsControllerGetStatsV1QueryKey = (
  options: Options<AppScanLocationsControllerGetStatsV1Data>
) => createQueryKey("appScanLocationsControllerGetStatsV1", options);

/**
 * Get package statistics for a scan location
 */
export const appScanLocationsControllerGetStatsV1Options = (
  options: Options<AppScanLocationsControllerGetStatsV1Data>
) =>
  queryOptions<
    AppScanLocationsControllerGetStatsV1Response,
    DefaultError,
    AppScanLocationsControllerGetStatsV1Response,
    ReturnType<typeof appScanLocationsControllerGetStatsV1QueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await appScanLocationsControllerGetStatsV1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: appScanLocationsControllerGetStatsV1QueryKey(options),
  });

export const appScanLocationsControllerFindByIdWithDetailsV1QueryKey = (
  options: Options<AppScanLocationsControllerFindByIdWithDetailsV1Data>
) => createQueryKey("appScanLocationsControllerFindByIdWithDetailsV1", options);

/**
 * Get scan location by ID with full details
 *
 * Returns scan location with assigned users, recent package events (last 4), and company info
 */
export const appScanLocationsControllerFindByIdWithDetailsV1Options = (
  options: Options<AppScanLocationsControllerFindByIdWithDetailsV1Data>
) =>
  queryOptions<
    AppScanLocationsControllerFindByIdWithDetailsV1Response,
    DefaultError,
    AppScanLocationsControllerFindByIdWithDetailsV1Response,
    ReturnType<typeof appScanLocationsControllerFindByIdWithDetailsV1QueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await appScanLocationsControllerFindByIdWithDetailsV1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: appScanLocationsControllerFindByIdWithDetailsV1QueryKey(options),
  });

export const appScanLocationsControllerFindByIdV1QueryKey = (
  options: Options<AppScanLocationsControllerFindByIdV1Data>
) => createQueryKey("appScanLocationsControllerFindByIdV1", options);

/**
 * Get scan location by ID
 */
export const appScanLocationsControllerFindByIdV1Options = (
  options: Options<AppScanLocationsControllerFindByIdV1Data>
) =>
  queryOptions<
    AppScanLocationsControllerFindByIdV1Response,
    DefaultError,
    AppScanLocationsControllerFindByIdV1Response,
    ReturnType<typeof appScanLocationsControllerFindByIdV1QueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await appScanLocationsControllerFindByIdV1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: appScanLocationsControllerFindByIdV1QueryKey(options),
  });

/**
 * Update scan location by ID
 */
export const appScanLocationsControllerUpdateV1Mutation = (
  options?: Partial<Options<AppScanLocationsControllerUpdateV1Data>>
): UseMutationOptions<
  AppScanLocationsControllerUpdateV1Response,
  DefaultError,
  Options<AppScanLocationsControllerUpdateV1Data>
> => {
  const mutationOptions: UseMutationOptions<
    AppScanLocationsControllerUpdateV1Response,
    DefaultError,
    Options<AppScanLocationsControllerUpdateV1Data>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await appScanLocationsControllerUpdateV1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Deactivate a scan location
 */
export const appScanLocationsControllerDeactivateV1Mutation = (
  options?: Partial<Options<AppScanLocationsControllerDeactivateV1Data>>
): UseMutationOptions<
  unknown,
  DefaultError,
  Options<AppScanLocationsControllerDeactivateV1Data>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    DefaultError,
    Options<AppScanLocationsControllerDeactivateV1Data>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await appScanLocationsControllerDeactivateV1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const appScanLocationsControllerSearchUsersV1QueryKey = (
  options: Options<AppScanLocationsControllerSearchUsersV1Data>
) => createQueryKey("appScanLocationsControllerSearchUsersV1", options);

/**
 * Search users for a scan location
 *
 * Search company users by email or name. Email matches get priority in sorting.
 */
export const appScanLocationsControllerSearchUsersV1Options = (
  options: Options<AppScanLocationsControllerSearchUsersV1Data>
) =>
  queryOptions<
    AppScanLocationsControllerSearchUsersV1Response,
    DefaultError,
    AppScanLocationsControllerSearchUsersV1Response,
    ReturnType<typeof appScanLocationsControllerSearchUsersV1QueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await appScanLocationsControllerSearchUsersV1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: appScanLocationsControllerSearchUsersV1QueryKey(options),
  });

export const appScanLocationsControllerGetAssignedUsersV1QueryKey = (
  options: Options<AppScanLocationsControllerGetAssignedUsersV1Data>
) => createQueryKey("appScanLocationsControllerGetAssignedUsersV1", options);

/**
 * Get assigned users for a scan location with scan counts
 *
 * Returns list of assigned users with location-specific scan counts and recent activity
 */
export const appScanLocationsControllerGetAssignedUsersV1Options = (
  options: Options<AppScanLocationsControllerGetAssignedUsersV1Data>
) =>
  queryOptions<
    AppScanLocationsControllerGetAssignedUsersV1Response,
    DefaultError,
    AppScanLocationsControllerGetAssignedUsersV1Response,
    ReturnType<typeof appScanLocationsControllerGetAssignedUsersV1QueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await appScanLocationsControllerGetAssignedUsersV1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: appScanLocationsControllerGetAssignedUsersV1QueryKey(options),
  });

/**
 * Assign user to scan location
 */
export const appScanLocationsControllerAssignUserV1Mutation = (
  options?: Partial<Options<AppScanLocationsControllerAssignUserV1Data>>
): UseMutationOptions<
  unknown,
  DefaultError,
  Options<AppScanLocationsControllerAssignUserV1Data>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    DefaultError,
    Options<AppScanLocationsControllerAssignUserV1Data>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await appScanLocationsControllerAssignUserV1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Bulk assign multiple users to a scan location
 */
export const appScanLocationsControllerBulkAddUsersV1Mutation = (
  options?: Partial<Options<AppScanLocationsControllerBulkAddUsersV1Data>>
): UseMutationOptions<
  AppScanLocationsControllerBulkAddUsersV1Response,
  DefaultError,
  Options<AppScanLocationsControllerBulkAddUsersV1Data>
> => {
  const mutationOptions: UseMutationOptions<
    AppScanLocationsControllerBulkAddUsersV1Response,
    DefaultError,
    Options<AppScanLocationsControllerBulkAddUsersV1Data>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await appScanLocationsControllerBulkAddUsersV1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Unassign user from scan location
 */
export const appScanLocationsControllerUnassignUserV1Mutation = (
  options?: Partial<Options<AppScanLocationsControllerUnassignUserV1Data>>
): UseMutationOptions<
  AppScanLocationsControllerUnassignUserV1Response,
  DefaultError,
  Options<AppScanLocationsControllerUnassignUserV1Data>
> => {
  const mutationOptions: UseMutationOptions<
    AppScanLocationsControllerUnassignUserV1Response,
    DefaultError,
    Options<AppScanLocationsControllerUnassignUserV1Data>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await appScanLocationsControllerUnassignUserV1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const appTeamControllerFindAllV1QueryKey = (
  options?: Options<AppTeamControllerFindAllV1Data>
) => createQueryKey("appTeamControllerFindAllV1", options);

/**
 * List team members for your company
 */
export const appTeamControllerFindAllV1Options = (
  options?: Options<AppTeamControllerFindAllV1Data>
) =>
  queryOptions<
    AppTeamControllerFindAllV1Response,
    DefaultError,
    AppTeamControllerFindAllV1Response,
    ReturnType<typeof appTeamControllerFindAllV1QueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await appTeamControllerFindAllV1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: appTeamControllerFindAllV1QueryKey(options),
  });

/**
 * Invite a user to your company
 */
export const appTeamControllerInviteV1Mutation = (
  options?: Partial<Options<AppTeamControllerInviteV1Data>>
): UseMutationOptions<unknown, DefaultError, Options<AppTeamControllerInviteV1Data>> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    DefaultError,
    Options<AppTeamControllerInviteV1Data>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await appTeamControllerInviteV1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Change a team member role
 */
export const appTeamControllerChangeRoleV1Mutation = (
  options?: Partial<Options<AppTeamControllerChangeRoleV1Data>>
): UseMutationOptions<unknown, DefaultError, Options<AppTeamControllerChangeRoleV1Data>> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    DefaultError,
    Options<AppTeamControllerChangeRoleV1Data>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await appTeamControllerChangeRoleV1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Remove a team member from your company
 */
export const appTeamControllerRemoveV1Mutation = (
  options?: Partial<Options<AppTeamControllerRemoveV1Data>>
): UseMutationOptions<
  AppTeamControllerRemoveV1Response,
  DefaultError,
  Options<AppTeamControllerRemoveV1Data>
> => {
  const mutationOptions: UseMutationOptions<
    AppTeamControllerRemoveV1Response,
    DefaultError,
    Options<AppTeamControllerRemoveV1Data>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await appTeamControllerRemoveV1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Initiate Shopify OAuth connection
 *
 * Generates a Shopify authorization URL for the company to connect their store
 */
export const appShopifyControllerConnectV1Mutation = (
  options?: Partial<Options<AppShopifyControllerConnectV1Data>>
): UseMutationOptions<
  AppShopifyControllerConnectV1Response,
  DefaultError,
  Options<AppShopifyControllerConnectV1Data>
> => {
  const mutationOptions: UseMutationOptions<
    AppShopifyControllerConnectV1Response,
    DefaultError,
    Options<AppShopifyControllerConnectV1Data>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await appShopifyControllerConnectV1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const appShopifyControllerGetStatusV1QueryKey = (
  options: Options<AppShopifyControllerGetStatusV1Data>
) => createQueryKey("appShopifyControllerGetStatusV1", options);

/**
 * Get Shopify connection status for a shop
 *
 * Returns whether the shop is connected to Shopify and connection details
 */
export const appShopifyControllerGetStatusV1Options = (
  options: Options<AppShopifyControllerGetStatusV1Data>
) =>
  queryOptions<
    AppShopifyControllerGetStatusV1Response,
    DefaultError,
    AppShopifyControllerGetStatusV1Response,
    ReturnType<typeof appShopifyControllerGetStatusV1QueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await appShopifyControllerGetStatusV1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: appShopifyControllerGetStatusV1QueryKey(options),
  });

/**
 * Disconnect Shopify integration for a shop
 *
 * Removes stored Shopify OAuth tokens/domain from the shop so it is no longer connected.
 */
export const appShopifyControllerDisconnectV1Mutation = (
  options?: Partial<Options<AppShopifyControllerDisconnectV1Data>>
): UseMutationOptions<
  AppShopifyControllerDisconnectV1Response,
  DefaultError,
  Options<AppShopifyControllerDisconnectV1Data>
> => {
  const mutationOptions: UseMutationOptions<
    AppShopifyControllerDisconnectV1Response,
    DefaultError,
    Options<AppShopifyControllerDisconnectV1Data>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await appShopifyControllerDisconnectV1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const appShopifyControllerGetRecentOrdersV1QueryKey = (
  options: Options<AppShopifyControllerGetRecentOrdersV1Data>
) => createQueryKey("appShopifyControllerGetRecentOrdersV1", options);

/**
 * Get recent cached Shopify orders
 *
 * Returns the 20 most recent orders from cache. Users can select from these to link to packages.
 */
export const appShopifyControllerGetRecentOrdersV1Options = (
  options: Options<AppShopifyControllerGetRecentOrdersV1Data>
) =>
  queryOptions<
    AppShopifyControllerGetRecentOrdersV1Response,
    DefaultError,
    AppShopifyControllerGetRecentOrdersV1Response,
    ReturnType<typeof appShopifyControllerGetRecentOrdersV1QueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await appShopifyControllerGetRecentOrdersV1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: appShopifyControllerGetRecentOrdersV1QueryKey(options),
  });

/**
 * Sync recent Shopify orders into cache
 *
 * Refreshes the 20 most recent Shopify orders for a connected shop and returns a sync summary.
 */
export const appShopifyControllerSyncOrdersV1Mutation = (
  options?: Partial<Options<AppShopifyControllerSyncOrdersV1Data>>
): UseMutationOptions<
  AppShopifyControllerSyncOrdersV1Response,
  DefaultError,
  Options<AppShopifyControllerSyncOrdersV1Data>
> => {
  const mutationOptions: UseMutationOptions<
    AppShopifyControllerSyncOrdersV1Response,
    DefaultError,
    Options<AppShopifyControllerSyncOrdersV1Data>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await appShopifyControllerSyncOrdersV1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const appShopifyControllerSearchOrdersV1QueryKey = (
  options: Options<AppShopifyControllerSearchOrdersV1Data>
) => createQueryKey("appShopifyControllerSearchOrdersV1", options);

/**
 * Search Shopify orders
 *
 * Full-text search across order number, customer name, email, and shipping address. Cached orders are searched locally (supports address matching), then Shopify API is queried, and results are merged and deduplicated.
 */
export const appShopifyControllerSearchOrdersV1Options = (
  options: Options<AppShopifyControllerSearchOrdersV1Data>
) =>
  queryOptions<
    AppShopifyControllerSearchOrdersV1Response,
    DefaultError,
    AppShopifyControllerSearchOrdersV1Response,
    ReturnType<typeof appShopifyControllerSearchOrdersV1QueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await appShopifyControllerSearchOrdersV1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: appShopifyControllerSearchOrdersV1QueryKey(options),
  });

/**
 * Associate a package with a Shopify order
 *
 * Creates a SENT PackageEvent linking the package to the order. Auto-creates an ExternalDestination from the order shipping address if applicable.
 */
export const appShopifyControllerAssociatePackageWithOrderV1Mutation = (
  options?: Partial<Options<AppShopifyControllerAssociatePackageWithOrderV1Data>>
): UseMutationOptions<
  AppShopifyControllerAssociatePackageWithOrderV1Response,
  DefaultError,
  Options<AppShopifyControllerAssociatePackageWithOrderV1Data>
> => {
  const mutationOptions: UseMutationOptions<
    AppShopifyControllerAssociatePackageWithOrderV1Response,
    DefaultError,
    Options<AppShopifyControllerAssociatePackageWithOrderV1Data>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await appShopifyControllerAssociatePackageWithOrderV1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const appShopifyControllerGetSettingsV1QueryKey = (
  options: Options<AppShopifyControllerGetSettingsV1Data>
) => createQueryKey("appShopifyControllerGetSettingsV1", options);

/**
 * Get Shopify merchant settings for a shop
 *
 * Returns the stored Shopify embedded-app configuration for the given shop
 */
export const appShopifyControllerGetSettingsV1Options = (
  options: Options<AppShopifyControllerGetSettingsV1Data>
) =>
  queryOptions<
    AppShopifyControllerGetSettingsV1Response,
    DefaultError,
    AppShopifyControllerGetSettingsV1Response,
    ReturnType<typeof appShopifyControllerGetSettingsV1QueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await appShopifyControllerGetSettingsV1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: appShopifyControllerGetSettingsV1QueryKey(options),
  });

/**
 * Update Shopify merchant settings for a shop
 *
 * Partially updates the Shopify embedded-app configuration for the given shop
 */
export const appShopifyControllerUpdateSettingsV1Mutation = (
  options?: Partial<Options<AppShopifyControllerUpdateSettingsV1Data>>
): UseMutationOptions<
  AppShopifyControllerUpdateSettingsV1Response,
  DefaultError,
  Options<AppShopifyControllerUpdateSettingsV1Data>
> => {
  const mutationOptions: UseMutationOptions<
    AppShopifyControllerUpdateSettingsV1Response,
    DefaultError,
    Options<AppShopifyControllerUpdateSettingsV1Data>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await appShopifyControllerUpdateSettingsV1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const appOnboardingControllerGetProgressV1QueryKey = (
  options?: Options<AppOnboardingControllerGetProgressV1Data>
) => createQueryKey("appOnboardingControllerGetProgressV1", options);

/**
 * Get onboarding progress for current user
 */
export const appOnboardingControllerGetProgressV1Options = (
  options?: Options<AppOnboardingControllerGetProgressV1Data>
) =>
  queryOptions<
    AppOnboardingControllerGetProgressV1Response,
    DefaultError,
    AppOnboardingControllerGetProgressV1Response,
    ReturnType<typeof appOnboardingControllerGetProgressV1QueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await appOnboardingControllerGetProgressV1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: appOnboardingControllerGetProgressV1QueryKey(options),
  });

/**
 * Register new user and company
 */
export const appOnboardingControllerRegisterV1Mutation = (
  options?: Partial<Options<AppOnboardingControllerRegisterV1Data>>
): UseMutationOptions<
  AppOnboardingControllerRegisterV1Response,
  DefaultError,
  Options<AppOnboardingControllerRegisterV1Data>
> => {
  const mutationOptions: UseMutationOptions<
    AppOnboardingControllerRegisterV1Response,
    DefaultError,
    Options<AppOnboardingControllerRegisterV1Data>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await appOnboardingControllerRegisterV1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Verify email and auto-login
 */
export const appOnboardingControllerVerifyEmailV1Mutation = (
  options?: Partial<Options<AppOnboardingControllerVerifyEmailV1Data>>
): UseMutationOptions<
  AppOnboardingControllerVerifyEmailV1Response,
  DefaultError,
  Options<AppOnboardingControllerVerifyEmailV1Data>
> => {
  const mutationOptions: UseMutationOptions<
    AppOnboardingControllerVerifyEmailV1Response,
    DefaultError,
    Options<AppOnboardingControllerVerifyEmailV1Data>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await appOnboardingControllerVerifyEmailV1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Complete Google OAuth registration with company creation
 */
export const appOnboardingControllerRegisterGoogleV1Mutation = (
  options?: Partial<Options<AppOnboardingControllerRegisterGoogleV1Data>>
): UseMutationOptions<
  AppOnboardingControllerRegisterGoogleV1Response,
  DefaultError,
  Options<AppOnboardingControllerRegisterGoogleV1Data>
> => {
  const mutationOptions: UseMutationOptions<
    AppOnboardingControllerRegisterGoogleV1Response,
    DefaultError,
    Options<AppOnboardingControllerRegisterGoogleV1Data>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await appOnboardingControllerRegisterGoogleV1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Complete company profile during onboarding
 */
export const appOnboardingControllerCompleteProfileV1Mutation = (
  options?: Partial<Options<AppOnboardingControllerCompleteProfileV1Data>>
): UseMutationOptions<
  AppOnboardingControllerCompleteProfileV1Response,
  DefaultError,
  Options<AppOnboardingControllerCompleteProfileV1Data>
> => {
  const mutationOptions: UseMutationOptions<
    AppOnboardingControllerCompleteProfileV1Response,
    DefaultError,
    Options<AppOnboardingControllerCompleteProfileV1Data>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await appOnboardingControllerCompleteProfileV1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Create Stripe checkout session for subscription
 */
export const appOnboardingControllerCreateCheckoutSessionV1Mutation = (
  options?: Partial<Options<AppOnboardingControllerCreateCheckoutSessionV1Data>>
): UseMutationOptions<
  unknown,
  DefaultError,
  Options<AppOnboardingControllerCreateCheckoutSessionV1Data>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    DefaultError,
    Options<AppOnboardingControllerCreateCheckoutSessionV1Data>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await appOnboardingControllerCreateCheckoutSessionV1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const appExternalDestinationsControllerFindAllV1QueryKey = (
  options?: Options<AppExternalDestinationsControllerFindAllV1Data>
) => createQueryKey("appExternalDestinationsControllerFindAllV1", options);

/**
 * List all external destinations for current company
 *
 * Returns paginated list of shipping addresses
 */
export const appExternalDestinationsControllerFindAllV1Options = (
  options?: Options<AppExternalDestinationsControllerFindAllV1Data>
) =>
  queryOptions<
    AppExternalDestinationsControllerFindAllV1Response,
    DefaultError,
    AppExternalDestinationsControllerFindAllV1Response,
    ReturnType<typeof appExternalDestinationsControllerFindAllV1QueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await appExternalDestinationsControllerFindAllV1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: appExternalDestinationsControllerFindAllV1QueryKey(options),
  });

export const appExternalDestinationsControllerFindAllV1InfiniteQueryKey = (
  options?: Options<AppExternalDestinationsControllerFindAllV1Data>
): QueryKey<Options<AppExternalDestinationsControllerFindAllV1Data>> =>
  createQueryKey("appExternalDestinationsControllerFindAllV1", options, true);

/**
 * List all external destinations for current company
 *
 * Returns paginated list of shipping addresses
 */
export const appExternalDestinationsControllerFindAllV1InfiniteOptions = (
  options?: Options<AppExternalDestinationsControllerFindAllV1Data>
) =>
  infiniteQueryOptions<
    AppExternalDestinationsControllerFindAllV1Response,
    DefaultError,
    InfiniteData<AppExternalDestinationsControllerFindAllV1Response>,
    QueryKey<Options<AppExternalDestinationsControllerFindAllV1Data>>,
    | number
    | Pick<
        QueryKey<Options<AppExternalDestinationsControllerFindAllV1Data>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<AppExternalDestinationsControllerFindAllV1Data>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  page: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await appExternalDestinationsControllerFindAllV1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: appExternalDestinationsControllerFindAllV1InfiniteQueryKey(options),
    }
  );

/**
 * Create external destination (e.g., Shopify order address)
 *
 * Creates a shipping address destination linked to a package
 */
export const appExternalDestinationsControllerCreateV1Mutation = (
  options?: Partial<Options<AppExternalDestinationsControllerCreateV1Data>>
): UseMutationOptions<
  AppExternalDestinationsControllerCreateV1Response,
  DefaultError,
  Options<AppExternalDestinationsControllerCreateV1Data>
> => {
  const mutationOptions: UseMutationOptions<
    AppExternalDestinationsControllerCreateV1Response,
    DefaultError,
    Options<AppExternalDestinationsControllerCreateV1Data>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await appExternalDestinationsControllerCreateV1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Backfill geocoordinates for external destinations with missing lat/lon
 *
 * Finds all external destinations for your company that are missing latitude/longitude and geocodes them. Processes sequentially with 1-second delays to respect Nominatim rate limits.
 */
export const appExternalDestinationsControllerReconcileGeocoordinatesV1Mutation = (
  options?: Partial<Options<AppExternalDestinationsControllerReconcileGeocoordinatesV1Data>>
): UseMutationOptions<
  AppExternalDestinationsControllerReconcileGeocoordinatesV1Response,
  DefaultError,
  Options<AppExternalDestinationsControllerReconcileGeocoordinatesV1Data>
> => {
  const mutationOptions: UseMutationOptions<
    AppExternalDestinationsControllerReconcileGeocoordinatesV1Response,
    DefaultError,
    Options<AppExternalDestinationsControllerReconcileGeocoordinatesV1Data>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await appExternalDestinationsControllerReconcileGeocoordinatesV1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const appExternalDestinationsControllerFindByIdV1QueryKey = (
  options: Options<AppExternalDestinationsControllerFindByIdV1Data>
) => createQueryKey("appExternalDestinationsControllerFindByIdV1", options);

/**
 * Get external destination by ID
 */
export const appExternalDestinationsControllerFindByIdV1Options = (
  options: Options<AppExternalDestinationsControllerFindByIdV1Data>
) =>
  queryOptions<
    AppExternalDestinationsControllerFindByIdV1Response,
    DefaultError,
    AppExternalDestinationsControllerFindByIdV1Response,
    ReturnType<typeof appExternalDestinationsControllerFindByIdV1QueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await appExternalDestinationsControllerFindByIdV1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: appExternalDestinationsControllerFindByIdV1QueryKey(options),
  });

/**
 * Update external destination
 */
export const appExternalDestinationsControllerUpdateV1Mutation = (
  options?: Partial<Options<AppExternalDestinationsControllerUpdateV1Data>>
): UseMutationOptions<
  AppExternalDestinationsControllerUpdateV1Response,
  DefaultError,
  Options<AppExternalDestinationsControllerUpdateV1Data>
> => {
  const mutationOptions: UseMutationOptions<
    AppExternalDestinationsControllerUpdateV1Response,
    DefaultError,
    Options<AppExternalDestinationsControllerUpdateV1Data>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await appExternalDestinationsControllerUpdateV1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const appPackagingsControllerFindAllV1QueryKey = (
  options?: Options<AppPackagingsControllerFindAllV1Data>
) => createQueryKey("appPackagingsControllerFindAllV1", options);

/**
 * List all packaging types
 *
 * Returns all available packaging types. Price fields are excluded; use contract endpoints for pricing.
 */
export const appPackagingsControllerFindAllV1Options = (
  options?: Options<AppPackagingsControllerFindAllV1Data>
) =>
  queryOptions<
    AppPackagingsControllerFindAllV1Response,
    DefaultError,
    AppPackagingsControllerFindAllV1Response,
    ReturnType<typeof appPackagingsControllerFindAllV1QueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await appPackagingsControllerFindAllV1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: appPackagingsControllerFindAllV1QueryKey(options),
  });

export const appPackagingsControllerFindAllV1InfiniteQueryKey = (
  options?: Options<AppPackagingsControllerFindAllV1Data>
): QueryKey<Options<AppPackagingsControllerFindAllV1Data>> =>
  createQueryKey("appPackagingsControllerFindAllV1", options, true);

/**
 * List all packaging types
 *
 * Returns all available packaging types. Price fields are excluded; use contract endpoints for pricing.
 */
export const appPackagingsControllerFindAllV1InfiniteOptions = (
  options?: Options<AppPackagingsControllerFindAllV1Data>
) =>
  infiniteQueryOptions<
    AppPackagingsControllerFindAllV1Response,
    DefaultError,
    InfiniteData<AppPackagingsControllerFindAllV1Response>,
    QueryKey<Options<AppPackagingsControllerFindAllV1Data>>,
    | number
    | Pick<
        QueryKey<Options<AppPackagingsControllerFindAllV1Data>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<AppPackagingsControllerFindAllV1Data>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  page: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await appPackagingsControllerFindAllV1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: appPackagingsControllerFindAllV1InfiniteQueryKey(options),
    }
  );

export const appPackagingsControllerFindByCodeV1QueryKey = (
  options: Options<AppPackagingsControllerFindByCodeV1Data>
) => createQueryKey("appPackagingsControllerFindByCodeV1", options);

/**
 * Get packaging by code (e.g., HC_BOX_M_V2)
 */
export const appPackagingsControllerFindByCodeV1Options = (
  options: Options<AppPackagingsControllerFindByCodeV1Data>
) =>
  queryOptions<
    AppPackagingsControllerFindByCodeV1Response,
    DefaultError,
    AppPackagingsControllerFindByCodeV1Response,
    ReturnType<typeof appPackagingsControllerFindByCodeV1QueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await appPackagingsControllerFindByCodeV1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: appPackagingsControllerFindByCodeV1QueryKey(options),
  });

export const appPackagingsControllerFindByIdV1QueryKey = (
  options: Options<AppPackagingsControllerFindByIdV1Data>
) => createQueryKey("appPackagingsControllerFindByIdV1", options);

/**
 * Get packaging by ID
 */
export const appPackagingsControllerFindByIdV1Options = (
  options: Options<AppPackagingsControllerFindByIdV1Data>
) =>
  queryOptions<
    AppPackagingsControllerFindByIdV1Response,
    DefaultError,
    AppPackagingsControllerFindByIdV1Response,
    ReturnType<typeof appPackagingsControllerFindByIdV1QueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await appPackagingsControllerFindByIdV1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: appPackagingsControllerFindByIdV1QueryKey(options),
  });

export const appShopsControllerFindAllV1QueryKey = (
  options?: Options<AppShopsControllerFindAllV1Data>
) => createQueryKey("appShopsControllerFindAllV1", options);

/**
 * List shops for current company
 *
 * Returns all shops belonging to the authenticated user's company
 */
export const appShopsControllerFindAllV1Options = (
  options?: Options<AppShopsControllerFindAllV1Data>
) =>
  queryOptions<
    AppShopsControllerFindAllV1Response,
    DefaultError,
    AppShopsControllerFindAllV1Response,
    ReturnType<typeof appShopsControllerFindAllV1QueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await appShopsControllerFindAllV1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: appShopsControllerFindAllV1QueryKey(options),
  });

export const authControllerLoginV1Mutation = (
  options?: Partial<Options<AuthControllerLoginV1Data>>
): UseMutationOptions<
  AuthControllerLoginV1Response,
  DefaultError,
  Options<AuthControllerLoginV1Data>
> => {
  const mutationOptions: UseMutationOptions<
    AuthControllerLoginV1Response,
    DefaultError,
    Options<AuthControllerLoginV1Data>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await authControllerLoginV1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const authControllerRegisterV1Mutation = (
  options?: Partial<Options<AuthControllerRegisterV1Data>>
): UseMutationOptions<
  AuthControllerRegisterV1Response,
  DefaultError,
  Options<AuthControllerRegisterV1Data>
> => {
  const mutationOptions: UseMutationOptions<
    AuthControllerRegisterV1Response,
    DefaultError,
    Options<AuthControllerRegisterV1Data>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await authControllerRegisterV1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const authControllerConfirmEmailV1Mutation = (
  options?: Partial<Options<AuthControllerConfirmEmailV1Data>>
): UseMutationOptions<
  AuthControllerConfirmEmailV1Response,
  DefaultError,
  Options<AuthControllerConfirmEmailV1Data>
> => {
  const mutationOptions: UseMutationOptions<
    AuthControllerConfirmEmailV1Response,
    DefaultError,
    Options<AuthControllerConfirmEmailV1Data>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await authControllerConfirmEmailV1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const authControllerConfirmNewEmailV1Mutation = (
  options?: Partial<Options<AuthControllerConfirmNewEmailV1Data>>
): UseMutationOptions<
  AuthControllerConfirmNewEmailV1Response,
  DefaultError,
  Options<AuthControllerConfirmNewEmailV1Data>
> => {
  const mutationOptions: UseMutationOptions<
    AuthControllerConfirmNewEmailV1Response,
    DefaultError,
    Options<AuthControllerConfirmNewEmailV1Data>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await authControllerConfirmNewEmailV1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const authControllerForgotPasswordV1Mutation = (
  options?: Partial<Options<AuthControllerForgotPasswordV1Data>>
): UseMutationOptions<
  AuthControllerForgotPasswordV1Response,
  DefaultError,
  Options<AuthControllerForgotPasswordV1Data>
> => {
  const mutationOptions: UseMutationOptions<
    AuthControllerForgotPasswordV1Response,
    DefaultError,
    Options<AuthControllerForgotPasswordV1Data>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await authControllerForgotPasswordV1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const authControllerResetPasswordV1Mutation = (
  options?: Partial<Options<AuthControllerResetPasswordV1Data>>
): UseMutationOptions<
  AuthControllerResetPasswordV1Response,
  DefaultError,
  Options<AuthControllerResetPasswordV1Data>
> => {
  const mutationOptions: UseMutationOptions<
    AuthControllerResetPasswordV1Response,
    DefaultError,
    Options<AuthControllerResetPasswordV1Data>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await authControllerResetPasswordV1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const authControllerDeleteV1Mutation = (
  options?: Partial<Options<AuthControllerDeleteV1Data>>
): UseMutationOptions<
  AuthControllerDeleteV1Response,
  DefaultError,
  Options<AuthControllerDeleteV1Data>
> => {
  const mutationOptions: UseMutationOptions<
    AuthControllerDeleteV1Response,
    DefaultError,
    Options<AuthControllerDeleteV1Data>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await authControllerDeleteV1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const authControllerMeV1QueryKey = (options?: Options<AuthControllerMeV1Data>) =>
  createQueryKey("authControllerMeV1", options);

export const authControllerMeV1Options = (options?: Options<AuthControllerMeV1Data>) =>
  queryOptions<
    AuthControllerMeV1Response,
    DefaultError,
    AuthControllerMeV1Response,
    ReturnType<typeof authControllerMeV1QueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await authControllerMeV1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: authControllerMeV1QueryKey(options),
  });

export const authControllerUpdateV1Mutation = (
  options?: Partial<Options<AuthControllerUpdateV1Data>>
): UseMutationOptions<
  AuthControllerUpdateV1Response,
  DefaultError,
  Options<AuthControllerUpdateV1Data>
> => {
  const mutationOptions: UseMutationOptions<
    AuthControllerUpdateV1Response,
    DefaultError,
    Options<AuthControllerUpdateV1Data>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await authControllerUpdateV1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const authControllerRefreshV1Mutation = (
  options?: Partial<Options<AuthControllerRefreshV1Data>>
): UseMutationOptions<
  AuthControllerRefreshV1Response,
  DefaultError,
  Options<AuthControllerRefreshV1Data>
> => {
  const mutationOptions: UseMutationOptions<
    AuthControllerRefreshV1Response,
    DefaultError,
    Options<AuthControllerRefreshV1Data>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await authControllerRefreshV1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const authControllerLogoutV1Mutation = (
  options?: Partial<Options<AuthControllerLogoutV1Data>>
): UseMutationOptions<
  AuthControllerLogoutV1Response,
  DefaultError,
  Options<AuthControllerLogoutV1Data>
> => {
  const mutationOptions: UseMutationOptions<
    AuthControllerLogoutV1Response,
    DefaultError,
    Options<AuthControllerLogoutV1Data>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await authControllerLogoutV1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};
